import { useTheme } from 'styled-components';

import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const MinusIconGe: React.FC<SvgIconDefaultProps> = ({
  className,
  testId = 'minusIconGe',
  color,
}) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.interactive.brandColor;

  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="17"
      height="4"
      viewBox="0 0 17 4"
      fill="none"
    >
      <path
        d="M15.1613 3.44358H1.43907C0.641379 3.44358 -0.00537109 2.79683 -0.00537109 1.99913C-0.00537109 1.20144 0.641379 0.554688 1.43907 0.554688H15.1613C15.959 0.554688 16.6057 1.20144 16.6057 1.99913C16.6057 2.79683 15.959 3.44358 15.1613 3.44358Z"
        fill={iconColor}
      />
    </CustomSvg>
  );
};
export default MinusIconGe;
